import React from 'react';

export default function BottomSheet({ children }) {
  return children;
}
